module.exports = "<section class=\"nn-season-item container--large\"><a class=nn-season-item__inner ng-href=\"{{ ::('/seasons/' + season.translations[0].slug) }}\" lazy-background=\"{{ ::season.coverUrl }}\"><h2 class=nn-season-item__title ng-bind-html=::season.translations[0].title></h2><h3 class=nn-season-item__subtitle ng-bind-html=::season.translations[0].subtitle></h3><nn-base-button class=nn-season-item__btn>{{ \"VIEW_THE_PROGRAM\" | translate }}</nn-base-button></a></section>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-season-item/nn-season-item.directive.html
// module id = 1048
// module chunks = 0